import { Component, EventEmitter, Input, Output } from '@angular/core'
import { FormBuilder, FormGroup, Validators } from '@angular/forms'
import { MessageService } from 'primeng/api'

import { ApiOmnichannelTimelineService } from '../../data/services/api/api-omnichannel-timeline.service'
import { LOSS_REASON_OPTIONS } from '../../data/constants/client-event-type.constant'

@Component({
  selector: 'app-close-client-modal',
  templateUrl: './close-client-modal.component.html',
  styleUrls: ['./close-client-modal.component.scss'],
  providers: [MessageService],
})
export class CloseClientModalComponent {
  @Input() clientId!: string
  @Input() conversionStatus: string | null = null
  @Input() visible = false

  @Output() visibleChange = new EventEmitter<boolean>()
  @Output() closed = new EventEmitter<void>()

  //* value = key del enum cerrado del backend (Client.lossReason); label en español.
  reasons = LOSS_REASON_OPTIONS
  form: FormGroup

  constructor(private fb: FormBuilder, private api: ApiOmnichannelTimelineService, private messageService: MessageService) {
    this.form = this.fb.group({
      reason: [null, Validators.required],
    })
  }

  get canClose(): boolean {
    //* solo se cierra manualmente desde el funnel (pre-lease)
    return this.conversionStatus === 'in_funnel' || this.conversionStatus == null
  }

  submit(): void {
    if (this.form.invalid || !this.canClose) return
    //* se envía el VALUE del enum (no el label) — el backend valida @IsIn(LOSS_REASONS).
    this.api.closeClient(this.clientId, { outcome: 'lost', reason: this.form.value.reason }).subscribe((r) => {
      if (!r.error) {
        this.messageService.add({ severity: 'success', summary: 'Cliente marcado como perdido', detail: r.msg, life: 3000 })
        this.closed.emit()
        this.close()
      } else {
        this.messageService.add({ severity: 'error', summary: 'Error', detail: r.msg, life: 4000 })
      }
    })
  }

  close(): void {
    this.visible = false
    this.visibleChange.emit(false)
  }
}
